// define a mixin object
export const printMixins = {
    data() {
        return {

        }
    },
    created: function () {

    },
    methods: {

        hidden() {
            var $printSection = document.getElementById("printSection");
            if ($printSection) {
                $printSection.remove();
            }
        },
        print() {
            var domClone = document.getElementById("printContent").cloneNode(true);

            var $printSection = document.getElementById("printSection");
            if (!$printSection) {
                var $printSection = document.createElement("div");
                $printSection.id = "printSection";
                document.body.appendChild($printSection);
            }

            $printSection.innerHTML = "";
            $printSection.appendChild(domClone);
            window.print();
        },

    }
}
